import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from './app/app.config';
import { environment } from 'environments/environment';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';

if (environment.production) {
    Sentry.init({
        dsn: 'https://f0c72a20902471d8cdcba5eff30f15b4@o4509314803761152.ingest.de.sentry.io/4509314804940880',
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Session Replay wird bei 10% aller Sessions aufgezeichnet
        replaysSessionSampleRate: 0.1,
        // Session Replay wird bei 100% der Sessions mit Fehlern aufgezeichnet
        replaysOnErrorSampleRate: 1.0,
    });
}

if (environment.production) {
    enableProdMode();
    if (window) {
        window.console.log = () => {};
        window.console.error = () => {};
        window.console.warn = () => {};
    }
}
window.console.warn = () => {};

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch(err => console.error(err));
